
const Stack = () => {
    return (
        <div className="stack">
            <div className="technologies">
                <h3>Frontend</h3>                
                <hr></hr>
                <li>React</li>
                <li>JavaScript</li>
                <li>HTML</li>
                <li>CSS / Sass</li>
                <li>Bootstrap</li>
                <li>Responsive Design</li>
            </div>
            <div className="technologies">
                <h3>Backend</h3>
                <hr></hr>
                <li>PostgreSQL</li>
                <li>MongoDB</li>
                <li>Express.js</li>
                <li>Node.js</li>
                <li>Django</li>
                <li>Python</li>
            </div>
        </div>
    )
}

export default Stack